import { render, staticRenderFns } from "./QuoteApprovedStateCard.vue?vue&type=template&id=6cc6b2ee&"
import script from "./QuoteApprovedStateCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteApprovedStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports